export var computePsEsZoomTimes = function (timeline) {
    var baseEnd = timeline.timeWithEnergySavingOn
        ? timeline.timeWithEnergySavingOn.begin
        : timeline.timeToPartSecured.end;
    var keyDuration = baseEnd - timeline.vacuumOnBeforePick.begin;
    var psDuration = timeline.timeToPartSecured.end - timeline.timeToPartSecured.begin;
    return {
        startTime: 0,
        endTime: baseEnd + Math.max(psDuration, keyDuration * 0.25),
    };
};
export var computeAtmZoomTimes = function (timeline) {
    var start = timeline.releaseTimeToPlacePart.begin;
    var end = timeline.additionalReleaseTime.end;
    var duration = end - start;
    var padding = duration * 0.125;
    return {
        startTime: Math.max(0, start - padding),
        endTime: Math.min(timeline.totalTime, end + padding),
    };
};
var containsTime = function (_a, time) {
    var startTime = _a.startTime, endTime = _a.endTime;
    return time >= startTime && time <= endTime;
};
var rangesAlmostEqual = function (a, b) {
    return Math.abs(a.startTime - b.startTime) < 0.001 &&
        Math.abs(a.endTime - b.endTime) < 0.001;
};
var crossedIntoTime = function (previousRange, newRange, time) { return !containsTime(previousRange, time) && containsTime(newRange, time); };
export var getPresetZoomForDraggedRange = function (_a) {
    var timeline = _a.timeline, previousRange = _a.previousRange, newRange = _a.newRange, dragType = _a.dragType;
    if (dragType !== "body")
        return;
    if (crossedIntoTime(previousRange, newRange, timeline.releaseTimeToPlacePart.begin)) {
        var atmRange = computeAtmZoomTimes(timeline);
        return rangesAlmostEqual(previousRange, atmRange) ? undefined : atmRange;
    }
    if (crossedIntoTime(previousRange, newRange, timeline.timeToPartSecured.end)) {
        var psEsRange = computePsEsZoomTimes(timeline);
        return rangesAlmostEqual(previousRange, psEsRange) ? undefined : psEsRange;
    }
    return undefined;
};
